import React from 'react';
import { Link } from 'react-router-dom';
import { getCategory } from '../data/compounds';
import ScoreGauge from './ScoreGauge';
import './CompoundCard.css';

export default function CompoundCard({ compound, showCategory = false }) {
  const category = getCategory(compound.categoryId);

  const statusColors = {
    green: { bg: 'rgba(16,185,129,0.1)', border: 'rgba(16,185,129,0.25)', text: '#10b981' },
    orange: { bg: 'rgba(245,158,11,0.1)', border: 'rgba(245,158,11,0.25)', text: '#f59e0b' },
    red: { bg: 'rgba(239,68,68,0.1)', border: 'rgba(239,68,68,0.25)', text: '#ef4444' },
  };

  const sc = statusColors[compound.statusColor] || statusColors.green;

  const scheduleColors = {
    unscheduled: { bg: 'rgba(16,185,129,0.08)', border: 'rgba(16,185,129,0.2)', text: '#10b981', label: 'Unscheduled' },
    scheduled: { bg: 'rgba(239,68,68,0.08)', border: 'rgba(239,68,68,0.2)', text: '#ef4444', label: 'Scheduled' },
    monitor: { bg: 'rgba(245,158,11,0.08)', border: 'rgba(245,158,11,0.2)', text: '#f59e0b', label: 'Monitor' },
  };
  const shed = scheduleColors[compound.schedulingStatus] || scheduleColors.unscheduled;

  const confColors = { HIGH: '#10b981', MODERATE: '#f59e0b', LOW: '#64748b' };
  const confColor = confColors[compound.evidenceConfidence] || '#64748b';

  return (
    <Link to={`/compounds/${compound.id}`} className="compound-card" style={{ '--cat-color': category?.color || '#6366f1' }}>
      {/* Card top accent bar */}
      <div className="compound-card-accent" style={{ background: category?.color || '#6366f1' }} />

      {/* Header */}
      <div className="compound-card-header">
        <div className="compound-card-header-top">
          <div className="compound-card-badges">
            <span className="compound-card-status-badge" style={{ background: sc.bg, border: `1px solid ${sc.border}`, color: sc.text }}>
              {compound.status}
            </span>
            <span className="compound-card-evidence-badge" style={{ color: confColor }}>
              {compound.evidenceConfidence} confidence
            </span>
          </div>
        </div>
        <h3 className="compound-card-name">{compound.name}</h3>
        <div className="compound-card-fullname">{compound.fullName}</div>
        {showCategory && category && (
          <div className="compound-card-category" style={{ color: category.color }}>
            {category.icon} {category.name}
          </div>
        )}
      </div>

      {/* Scores */}
      <div className="compound-card-scores">
        <ScoreGauge score={compound.benefitScore} label="Benefit" type="benefit" size="small" />
        <div className="compound-card-scores-divider" />
        <ScoreGauge score={compound.harmScore} label="Risk" type="harm" size="small" />
      </div>

      {/* Formula & scheduling */}
      <div className="compound-card-meta">
        <span className="compound-card-formula">{compound.formula}</span>
        <span className="compound-card-schedule" style={{ background: shed.bg, border: `1px solid ${shed.border}`, color: shed.text }}>
          {shed.label}
        </span>
      </div>

      {/* Summary */}
      <p className="compound-card-summary">
        {(() => {
          const s = compound.summary || compound.description || '';
          return s.length > 140 ? s.slice(0, 140) + '…' : s;
        })()}
      </p>

      {/* Aliases */}
      {compound.aliases && (() => {
        // aliases can be an array OR a pipe-separated string from Excel imports
        const aliasArr = Array.isArray(compound.aliases)
          ? compound.aliases
          : String(compound.aliases).split('|').map(a => a.trim()).filter(Boolean);
        return aliasArr.length > 0 ? (
          <div className="compound-card-aliases">
            {aliasArr.slice(0, 2).map(a => (
              <span key={a} className="compound-card-alias-tag">{a}</span>
            ))}
          </div>
        ) : null;
      })()}

      {/* CTA */}
      <div className="compound-card-cta">
        Full Research Profile →
      </div>
    </Link>
  );
}